/**
 * Converts text to representing title case
 * @param text
 */
export const titleCase = (text?: string): string | undefined => {
  return text?.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}
